import { ArrowRight } from 'lucide-react';
import type { Blocker } from '../api';
import { stuckVerb } from '../lib/employee-feel';
import { useAgentName, withAgent } from '../agent-name';
import './stuck-strip.css';

/** Reason + next human verb for anything that is not moving (Monk stuck=verb bar). */
export function StuckStrip({ blockers, className = '' }: { blockers: Blocker[] | undefined; className?: string }) {
  const agent = useAgentName();
  const stuck = stuckVerb(blockers);
  if (!stuck) return null;
  return <aside className={`stuck-strip ${className}`.trim()} aria-label="What is stuck">
    <p className="stuck-reason"><span className="stuck-kicker">Stuck</span>{withAgent(stuck.reason, agent)}</p>
    <p className="stuck-verb">
      <span className="stuck-kicker">You</span>{withAgent(stuck.verb, agent)}
      {stuck.href && <a href={stuck.href}>{stuck.fixLabel ?? 'Open'}<ArrowRight size={13} aria-hidden /></a>}
    </p>
  </aside>;
}
